// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerAddressFormFieldStyles } from "@vanmeter/Overrides/Components/CustomerAddressFormFields";
import { fontConfig } from "@vanmeter/XDL/constants";

customerAddressFormFieldStyles.container = {
    gap: 18,
};

customerAddressFormFieldStyles.firstNameGridItem =
    customerAddressFormFieldStyles.lastNameGridItem =
    customerAddressFormFieldStyles.countryGridItem =
    customerAddressFormFieldStyles.emailGridItem =
    customerAddressFormFieldStyles.phoneGridItem =
    customerAddressFormFieldStyles.postalCodeGridItem =
    customerAddressFormFieldStyles.stateGridItem =
        {
            width: [12, 12, 12, 6, 6],
        };

customerAddressFormFieldStyles.companyNameGridItem = { width: 12 };
